import { List } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';
import type { INavMenuContext } from './NavMenuContext';
import { NavMenuContext } from './NavMenuContext';
import { NavMenuItem } from './NavMenuItem';
import { NavMenuLabel } from './NavMenuLabel';

export type INavMenuProps = IContainerProps &
  INavMenuContext & {
    children: React.ReactNode;
  };

const listStyles = stylex.create({
  content: {
    gap: '0.25rem',
  },
});

const NavMenu: React.FC<INavMenuProps> = ({ sx, dim, children }) => (
  <NavMenuContext.Provider value={{ dim }}>
    <List styles={listStyles} sx={sx}>
      {children}
    </List>
  </NavMenuContext.Provider>
);

const NavMenuNamespace = Object.assign(NavMenu, {
  Label: NavMenuLabel,
  Item: NavMenuItem,
});

export { NavMenuNamespace as NavMenu };
